import React, { useState } from "react";
import SidebarItem from "./SidebarItem";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const SidebarGroup = ({ icon, title, items, collapsed }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            {/* Group Header */}
            <div
                onClick={() => setIsOpen(!isOpen)}
                className={`
        flex items-center px-2 py-2 rounded-lg cursor-pointer transition-colors
        ${collapsed ? "justify-center" : "justify-between"}
        hover:bg-teal-600
    `}
            >
                <div className="flex items-center gap-3">
                    {icon}
                    {!collapsed && <span className="font-medium">{title}</span>}
                </div>
                {!collapsed && <span>{isOpen ? <FaChevronDown /> : <FaChevronRight />}</span>}
            </div>

            {/* Group Items */}
            {isOpen && !collapsed && (
                <div className="ml-6 flex flex-col gap-1 mt-1">
                    {items.map((item) => (
                        <SidebarItem
                            key={item.text}
                            icon={item.icon}
                            text={item.text}
                            link={item.link}
                            collapsed={collapsed}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SidebarGroup;